import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import { useGlobalContext } from "../../GlobalContext";
import BaseComponent, { BaseProps } from "../BaseComponent";

interface AppProps extends BaseProps {
  print?: boolean;
}
export default function BaseApplicationComponent(props: AppProps) {
  const { accountInfo } = useGlobalContext();
  const {
    application: { hasAppeal, hasTransfer },
    applicationBase,
  } = useApplicationContext();

  function showEdit() {
    return (
      props.disabled && !hasAppeal && !hasTransfer && (accountInfo.isInternal || (accountInfo.isKindergarten && applicationBase.canKindergartenEdit))
    );
  }

  return (
    <div className={"w-full" + (props.print ? "" : " dont-show-in-print")}>
      <BaseComponent
        {...props}
        showNoValidateBtn={props.showNoValidateBtn ?? applicationBase.isPresubmission}
        showEdit={props.showEdit ?? showEdit()}
        submitBtnTitle={(props.showNoValidateBtn ?? applicationBase.isPresubmission) ? "Check this Section for Errors" : props.submitBtnTitle}
      />
    </div>
  );
}
